import { BaseInputModel } from '@/helpers/entities/models/BaseInputModel';
export class PaymentOptionDetailInputModel extends BaseInputModel {
    constructor(payload = null) {
        super();
        if (payload) {
            Object.assign(this, payload);
            this.markAsFetched();
        }
        else {
            this.init();
        }
    }
    init() {
        this.uuid = null;
        this.content = null;
    }
}
